<script lang="ts">
    import DonationReportListing from '../../components/admin/report/donationReport/donationReportListing.svelte';
  </script>
  
  <div class="donation-report-listing-page">
    <DonationReportListing />
  </div>
  
  <style>
    .donation-report-listing-page {
      min-height: 100vh;
      background-color: #f9fafb;
    }
  </style>      